import React from 'react';

interface LoadingIndicatorProps {
  /**
   * Optional label. Defaults to "Loading…".
   * Use specific labels for context ("Loading installations…", etc.).
   */
  label?: string;
  marginTop?: number | string;
}

/**
 * Canonical loading indicator for Portal routes. Replaces the
 * inline `<div className="badge-subtle">Loading…</div>` pattern.
 *
 * The trailing character is always a single Unicode ellipsis to keep
 * loading copy visually consistent across surfaces (previous usage
 * mixed `...` and `…`).
 */
export const LoadingIndicator = ({
  label = 'Loading…',
  marginTop
}: LoadingIndicatorProps): JSX.Element => (
  <div
    className="badge-subtle"
    style={marginTop !== undefined ? { marginTop } : undefined}
    role="status"
    aria-live="polite"
  >
    {label}
  </div>
);
